import { IconProps } from '@/libs/types'
import React from 'react'

const GetEstimatesIcon: React.FC<IconProps> = ({
  height = 'h-6',
  width = 'w-6',
  additionalClasses = '',
  color = '#56A97F',
}) => {
  return (
    <svg
      className={`${height} ${width} ${additionalClasses}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 22"
      fill={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50183 5H8.24766L8.25 5H11.6299C13.4915 5.00268 14.9999 6.51269 14.9999 8.375V17.75C16.6567 17.75 17.9999 16.4068 17.9999 14.75V5.10821C17.9999 3.60282 16.8751 2.2966 15.3358 2.16884C15.1121 2.15027 14.8879 2.13321 14.6632 2.11767C14.1633 1.15647 13.1583 0.5 12 0.5H10.5C9.34168 0.5 8.33668 1.15647 7.83676 2.11765C7.61207 2.13319 7.38779 2.15026 7.16394 2.16884C5.66165 2.29353 4.55421 3.54069 4.50183 5ZM10.5 2C9.67157 2 9 2.67157 9 3.5H13.5C13.5 2.67157 12.8284 2 12 2H10.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.375C0 7.33947 0.839466 6.5 1.875 6.5H11.625C12.6605 6.5 13.5 7.33947 13.5 8.375V19.625C13.5 20.6605 12.6605 21.5 11.625 21.5H1.875C0.839466 21.5 0 20.6605 0 19.625V8.375ZM3 11C3 10.5858 3.33579 10.25 3.75 10.25H3.7575C4.17171 10.25 4.5075 10.5858 4.5075 11V11.0075C4.5075 11.4217 4.17171 11.7575 3.7575 11.7575H3.75C3.33579 11.7575 3 11.4217 3 11.0075V11ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H9.75C10.1642 10.25 10.5 10.5858 10.5 11C10.5 11.4142 10.1642 11.75 9.75 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM3 14C3 13.5858 3.33579 13.25 3.75 13.25H3.7575C4.17171 13.25 4.5075 13.5858 4.5075 14V14.0075C4.5075 14.4217 4.17171 14.7575 3.7575 14.7575H3.75C3.33579 14.7575 3 14.4217 3 14.0075V14ZM5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H9.75C10.1642 13.25 10.5 13.5858 10.5 14C10.5 14.4142 10.1642 14.75 9.75 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14ZM3 17C3 16.5858 3.33579 16.25 3.75 16.25H3.7575C4.17171 16.25 4.5075 16.5858 4.5075 17V17.0075C4.5075 17.4217 4.17171 17.7575 3.7575 17.7575H3.75C3.33579 17.7575 3 17.4217 3 17.0075V17ZM5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H9.75C10.1642 16.25 10.5 16.5858 10.5 17C10.5 17.4142 10.1642 17.75 9.75 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17Z"
        fill={color}
      />
    </svg>
  )
}

export default GetEstimatesIcon
